export const SITE_NAME = 'Aurevane Search Partners';

export const FAVICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="14" fill="#301D32"/><polygon points="14,52 29,12 36,12 21,52" fill="#F8F5F0"/><polygon points="33,12 37,12 52,52 45,52" fill="#F8F5F0" fill-opacity="0.55"/><rect x="20" y="36" width="30" height="4.5" fill="#A65F46"/></svg>`;

function upsertMeta(attribute: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}

function upsertLink(rel: string, href: string, type?: string) {
  let element = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    document.head.appendChild(element);
  }
  element.setAttribute('href', href);
  if (type) element.setAttribute('type', type);
}

export function applyPageMeta(title: string, description: string, jsonLd?: Record<string, unknown>) {
  const fullTitle = title === SITE_NAME ? `${SITE_NAME} | Executive Search Consultants` : `${title} | ${SITE_NAME}`;
  const url = window.location.origin + window.location.pathname;
  document.title = fullTitle;
  upsertMeta('name', 'description', description);
  upsertMeta('property', 'og:title', fullTitle);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:type', 'website');
  upsertMeta('property', 'og:site_name', SITE_NAME);
  upsertMeta('property', 'og:url', url);
  upsertMeta('property', 'og:image', faviconDataUri());
  upsertMeta('name', 'twitter:card', 'summary');
  upsertMeta('name', 'twitter:title', fullTitle);
  upsertMeta('name', 'twitter:description', description);
  upsertLink('canonical', url);

  const existing = document.getElementById('page-jsonld');
  if (existing) existing.remove();
  if (jsonLd) {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'page-jsonld';
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);
  }
}

export function faviconDataUri(): string {
  return `data:image/svg+xml,${encodeURIComponent(FAVICON_SVG)}`;
}

export function applyFavicon() {
  upsertLink('icon', faviconDataUri(), 'image/svg+xml');
  upsertMeta('name', 'theme-color', '#301D32');
}
